import React from "react";

const OptionButton = ({ option, onClick, isSelecting, label }) => {
  return (
    <button
      onClick={onClick}
      disabled={isSelecting}
      style={{
        ...styles.base,
        ...(option.selected ? styles.selected : styles.unselected),
        ...(isSelecting ? styles.disabled : {}),
      }}
    >
      <span style={{ marginRight: "10px", fontWeight: "bold" }}>{label}.</span>
      {option.option}
    </button>
  );
};

const styles = {
  base: {
    display: "block",
    width: "fit-content",
    minWidth: 220,
    padding: "10px 16px",
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 500,
    textAlign: "left",
    cursor: "pointer",
    transition: "background-color 0.15s ease, border-color 0.15s ease",
    outline: "none",
  },
  unselected: {
    backgroundColor: "#fff",
    border: "1px solid #d0d0d0",
    color: "#333",
  },
  selected: {
    backgroundColor: "#F5A623",
    border: "1px solid #F5A623",
    color: "#fff",
  },
  disabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
};

export default OptionButton;
